<template>
  <div class="row p-3 mt-2 bg-white shadow-sm bg-white" data-cy="file">
    <div class="col-1 text-center text-primary">
      <b-form-checkbox
        v-model="file.selected"
        @change="selectFile"
        data-cy="checkbox-file"
      >
      </b-form-checkbox>
    </div>
    <div class="col-1" data-cy="flow-number">
      <span v-if="file.app === 'FEB'" v-tooltip="'Flujo de Febos'">
        <vs-chip
          color="warning"
          :class="{ 'text-success': wasCopied }"
          class="cursor-pointer mr-2"
          data-cy="file-number"
          @click.native="copyToClipboard(file.idAprobacion, file.numero)"
        >
          {{file.numero}}
        </vs-chip>
      </span>
      <span
        v-if="file.app === 'ED' && file.tipoDocumento === 'ARCHIVO-RP'"
        v-tooltip="'Repositorio'"
      >
        <vs-chip
          color="primary"
          :class="{ 'text-success': wasCopied }"
          class="cursor-pointer mr-2"
          data-cy="file-number"
          @click.native="copyToClipboard(file.idAprobacion, file.numero)"
        >
          <vs-avatar color="primary" text="R"/>
          {{file.numero}}
        </vs-chip>
      </span>
      <span
        v-if="file.app === 'ED' && file.tipoDocumento === 'EXP'"
        v-tooltip="'Expediente'"
      >
        <vs-chip
          color="primary"
          :class="{ 'text-success': wasCopied }"
          class="cursor-pointer mr-2"
          data-cy="file-number"
          @click.native="copyToClipboard(file.idAprobacion, file.numero)"
        >
          <vs-avatar color="primary"  text="E"/>
          {{file.numero}}
        </vs-chip>
      </span>
      <span
        v-if="file.app === 'ED' && file.tipoDocumento === 'ARCHIVO'"
        v-tooltip="'Archivo'"
      >
        <vs-chip
          color="primary"
          :class="{ 'text-success': wasCopied }"
          class="cursor-pointer mr-2"
          data-cy="file-number"
          @click.native="copyToClipboard(file.idAprobacion, file.numero)"
        >
          <vs-avatar color="primary"  text="A"/>
          {{file.numero}}
        </vs-chip>
      </span>
    </div>
    <div class="col-2" data-cy="flow-name">
      <div v-tooltip="file.nombre" v-if="file.nombre.length > 30">
          {{ file.nombre.substring(0, 30) + '...' }}
      </div>
      <div v-else>{{ file.nombre }}</div>
    </div>
    <div class="col-2">
      <vs-chip
        v-if="file.aprovacionesEjecucionEstadoId.toString() === FileStates.DISMISSED"
        title="Desestimado"
        data-cy="dismissed"
      >
        <vs-avatar icon="mail_outline" color="#4e94e0" />
        Desestimado
      </vs-chip>
      <vs-chip
        title="Preparado"
        v-if="file.aprovacionesEjecucionEstadoId.toString() === FileStates.PREPARED"
        data-cy="prepared"
      >
        <vs-avatar icon="query_builder" color="#4e94e0" />
        Preparado
      </vs-chip>
      <vs-chip
        title="Iniciado"
        v-if="file.aprovacionesEjecucionEstadoId.toString() === FileStates.INITIATED"
        data-cy="initiated"
      >
        <vs-avatar icon="access_time" color="#43C3B9" />
        Iniciado
      </vs-chip>
      <vs-chip
        title="Aprobado"
        v-if="file.aprovacionesEjecucionEstadoId.toString() === FileStates.APPROVED"
        data-cy="aprobed"
      >
        <vs-avatar icon="thumb_up" color="#28c76f" />
        Aprobado
      </vs-chip>
      <vs-chip
        title="Rechazado"
        v-if="file.aprovacionesEjecucionEstadoId.toString() === FileStates.REJECTED"
        data-cy="rejected"
      >
        <vs-avatar icon="thumb_down" color="#ea5455" />
        Rechazado
      </vs-chip>
      <vs-chip
        title="Anulado"
        v-if="file.aprovacionesEjecucionEstadoId.toString() === FileStates.CANCELED"
        data-cy="canceled"
      >
        <vs-avatar icon="move_to_inbox" color="#ea5455" />
        Anulado
      </vs-chip>
    </div>
    <div class="col-2">
      <steps-info
        v-if="file.pasoEjecucion.aprobacionesPasoEstadoId"
        :step="file.pasoEjecucion.aprobacionesPasoEstadoId" />
    </div>
    <div class="col-2">
      {{ file.fechaInicioProceso }}
    </div>
    <div class="col-2">
      <vs-chip
        v-tooltip="'Nombre de documento en flujo'"
        color="warning" transparent
      >
        <vs-avatar icon="description" />
        {{ file.documentos[0].objetoNombre | truncate(20) }}
      </vs-chip>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import FileStates from '@/febos/chile/approvals/mixins/FileStates';
import StepsInfo from '@/febos/chile/approvals/components/substitutions/StepsInfo';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  mixins: [CopyToClipboard],
  components: {
    StepsInfo
  },
  props: [
    'file'
  ],
  data() {
    return {
      FileStates
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'selectedFile'
    ]),
  },
  methods: {
    selectFile() {
      if (this.file.selected) {
        this.$emit('select-flow', this.file);
        return;
      }
      this.$emit('unselect-flow', this.file);
    }
  }
};

</script>
<style>
.selected {
  background: #8e4aa01c !important;
}
</style>
